export { default } from "./billingPaymentPlanDetail";
